<i18n
  src="@/locales/components/views/agro_exporter/production/uniq_final_packing_list/show_container/tabs/sizes_by_pallet.yml"
  lang="yaml"
></i18n>
<template>
  <div>
    <h1 class="page-title">
      <i class="fa-solid fa-box"></i><span class="space-icon"></span>
      {{ $t("labels.title") }}
    </h1>

    <div class="flex flex-row justify-end">
      <tabs-download-buttons-packing-list
        :container_code="this.container.container_code"
        :container_id="this.container_id"
      />
    </div>

    <div
      class="mt-8 flex flex-col sm:flex-row space-x-4 space-y-8 sm:space-y-24"
    >
      <div class="grow table-first-container">
        <div class="table-second-container">
          <div class="table-third-container">
            <table class="table">
              <thead class="table-header">
                <tr class="border">
                  <th scope="col" rowspan="2" class="table-header-cell border">
                    {{ $t("labels.package_groups") }}
                  </th>
                  <th
                    scope="col"
                    :colspan="crop_sizes.length"
                    class="table-header-cell text-center"
                  >
                    {{ $t("labels.crop_size") }}
                  </th>
                  <th scope="col" rowspan="2" class="table-header-cell border">
                    {{ $t("labels.total") }}
                  </th>
                </tr>
                <tr>
                  <th
                    scope="col"
                    class="table-header-cell"
                    v-for="(crop_size, index) in crop_sizes"
                    :key="index"
                  >
                    {{ crop_size.name }}
                  </th>
                </tr>
              </thead>
              <tbody class="table-body">
                <tr v-for="pg in package_groups" :key="pg.id" class="table-row">
                  <td class="table-cell-main border">
                    {{ pg.pg_code }}
                  </td>
                  <td
                    class="table-cell border"
                    v-for="(crop_size, index) in crop_sizes"
                    :key="index"
                  >
                    {{ packagesByPalletCropSize(pg, crop_size) || "" }}
                  </td>
                  <td class="table-cell">{{ packagesByPallet(pg) }}</td>
                </tr>
                <tr class="table-row">
                  <td class="table-cell-main">{{ $t("labels.total") }}</td>
                  <td
                    class="table-cell border"
                    v-for="(crop_size, index) in crop_sizes"
                    :key="index"
                  >
                    {{ packagesByCropSize(crop_size) }}
                  </td>
                  <td class="table-cell border">{{ total_packages }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="flex-none h-min">
        <div
          class="grid grid-cols-2 bg-white rounded-md divide-x divide-y content-center items-center text-gray-500"
        >
          <div
            v-for="pg in package_groups_ordered"
            :key="pg.id"
            class="flex flex-col min-h-full py-7 px-4 text-center"
          >
            <span>{{ pg.pg_code }}</span>
            <span v-if="pg.thermo_code" class="italic text-sm">
              <i class="fa-solid fa-temperature-list text-red-600"></i>
              T. {{ pg.thermo_code }}
            </span>
          </div>
        </div>
      </div>
    </div>

    <div class="mt-8 flex flex-col">
      <div class="grow table-first-container">
        <div class="table-second-container">
          <div class="table-third-container">
            <table class="table">
              <thead class="table-header">
                <tr>
                  <th scope="col" class="table-header-cell">
                    {{ $t("labels.crop_size") }}
                  </th>
                  <th
                    scope="col"
                    class="table-header-cell"
                    v-for="(crop_size, index) in crop_sizes"
                    :key="index"
                  >
                    {{ crop_size.name }}
                  </th>
                  <th scope="col" class="table-header-cell">
                    {{ $t("labels.total") }}
                  </th>
                </tr>
              </thead>
              <tbody class="table-body">
                <tr class="table-row">
                  <td class="table-cell-main">{{ $t("labels.total") }}</td>
                  <td
                    class="table-cell"
                    v-for="(crop_size, index) in crop_sizes"
                    :key="index"
                  >
                    {{ packagesByCropSize(crop_size) }}
                  </td>
                  <td class="table-cell">{{ total_packages }}</td>
                </tr>
                <tr class="table-row">
                  <td class="table-cell-main">%</td>
                  <td
                    class="table-cell"
                    v-for="(crop_size, index) in crop_sizes"
                    :key="index"
                  >
                    {{
                      numberWithPrecision(
                        (packagesByCropSize(crop_size) / total_packages) * 100,
                        2
                      )
                    }}%
                  </td>
                  <td class="table-cell">{{ 100 }}%</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="flex-none sm:grid grid-cols-2 p-8"></div>
    </div>
  </div>
</template>

<script>
import TabsDownloadButtonsPackingList from "./DownloadButtonsPackingList.vue";
import TabsMixin from "@/components/views/agro_exporter/production/uniq_final_packing_list/show_container/tabs/mixin.js"

export default {
  name: "SizeByPalletTab",
  components: { TabsDownloadButtonsPackingList },
  mixins: [TabsMixin],
  data() {
    return {
      downloading: false,
      cols: this.container.cols_package_groups,
      rows: this.container.rows_package_groups
    };
  },
  props: {
    package_groups: {
      type: Array,
      required: true
    },
    container: { required: true }
  },
  computed: {
    crop_sizes() {
      let crop_sizes = [];
      this.package_groups
        .map(pg => pg.packages)
        .flat()
        .forEach(pkg => {
          if (
            !crop_sizes.find(cs => cs.id == pkg.exporter_process_crop_size.id)
          ) {
            crop_sizes.push({
              id: pkg.exporter_process_crop_size.id,
              name: pkg.exporter_process_crop_size.agro_exporter_crop_size
                .crop_size.name
            });
          }
        });
      return crop_sizes;
    },
    total_packages() {
      return this.package_groups
        .map(pg => pg.packages)
        .flat()
        .reduce((sum, pkg) => sum + pkg.quantity, 0);
    },
    package_groups_ordered() {
      let package_groups = [];
      for (let col = 1; col <= this.cols; col++) {
        for (let row = 1; row <= this.rows; row++) {
          let pkg_group = this.package_groups.find(
            pg => pg.col_position == col && pg.row_position == row
          );
          package_groups.push({
            id: pkg_group?.id,
            pg_code: pkg_group?.pg_code,
            thermo_code: pkg_group?.thermo_code,
            exporter_crop_size_id: pkg_group?.exporter_crop_size_id
          });
        }
      }
      return package_groups;
    }
  },
  methods: {
    packagesByPalletCropSize(package_group, crop_size) {
      let number = this.sumPackages(package_group.packages, crop_size);
      return this.formatNumber(number);
    },
    packagesByPallet(package_group) {
      let number = package_group.packages.reduce(
        (sum, pkg) => sum + pkg.quantity,
        0
      );
      return this.formatNumber(number);
    },
    packagesByCropSize(crop_size) {
      let packages = this.package_groups.map(pg => pg.packages).flat();
      let number = this.sumPackages(packages, crop_size);
      return number;
    },
    getPackageGroup(row, col) {
      return this.package_groups.find(
        pg => pg.col_position == col && pg.row_position == row
      );
    },
    sumPackages(packages, crop_size) {
      return packages
        .filter(pkg => pkg.exporter_process_crop_size.id == crop_size.id)
        .reduce((sum, pkg) => sum + pkg.quantity, 0);
    },
    formatNumber(number) {
      return number == 0 ? "" : this.numberWithPrecision(number);
    }
  }
};
</script>
